import React from "react";
import styles from "./Tooltip.module.scss";

export default function Tooltip({ title, items, children }) {
   return (
      <div className={styles.tooltipWrapper}>
         {children}
         <div className={styles.tooltipContent}>
            {title && title.trim() && <div className={styles.tooltipTitle}>{title}</div>}
            {items && items.length > 0 && (
               <ul className={styles.tooltipList}>
                  {items.map((item, index) => (
                     <li key={index}>{item}</li>
                  ))}
               </ul>
            )}
         </div>
      </div>
   );
}